import { motion } from "motion/react";
import styles from "./Card.module.css";

export default function EmptyGridCard() {
  return (
    <motion.div
      initial={{ opacity: [0.4, 1, 0.4] }}
      animate={{ opacity: [1, 0.4, 1] }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }}
      className={styles.gridCard}
    >
      <div className={styles.gridEmpty}>
        {/* <span className={styles.gridEmoji}>{item.emoji}</span> */}
        {/* {showMemberBadge && memberName && <span className={styles.badge}>{memberName}</span>} */}
        {/* <img className={styles.gridImageContent} src={imageURI as string} onLoad={handleImageLoad} /> */}
      </div>
    </motion.div>
  );
}
